export default {
      id: "location-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#location",
      toString: function () {
        return this.url;
      }
    }